import type { StreamingEvent } from '../../types/chat.types';
import type { ContentProcessorState } from '../contentProcessor.types';

export function handleA2UIEvent(
  state: ContentProcessorState,
  event: StreamingEvent<'a2ui'>,
): ContentProcessorState {
  const { surface_id, tool_use_id, message, surface_type } = event.data;

  const hasAnchor = state.nodes.some(
    (node) => node.type === 'a2ui-surface' && node.surfaceId === surface_id,
  );
  // Modal surfaces are hosted by the compose dock, not the message body.
  // Tab surfaces still get a transcript anchor; App Layer tab-view skips the card at render.
  const isCreate = 'createSurface' in message && surface_type !== 'modal';
  const nodes =
    isCreate && !hasAnchor
      ? [
          ...state.nodes,
          {
            type: 'a2ui-surface' as const,
            surfaceId: surface_id,
            toolUseId: tool_use_id,
          },
        ]
      : state.nodes;

  return {
    ...state,
    nodes,
    chunks: {
      ...state.chunks,
      // Clear pending progress once renderable content is emitted.
      progress: [],
      a2ui: [...state.chunks.a2ui, event.data],
    },
  };
}
